import { Outlet } from "react-router-dom"
import { Sidebar } from "./sidebar"
import { Header } from "./header"
import { ScrollArea } from "@/components/ui/scroll-area"

export function Layout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <ScrollArea className="flex-1">
          <main className="container mx-auto py-12 px-8 max-w-7xl">
            <Outlet />
          </main>
        </ScrollArea>
      </div>
    </div>
  )
}

